import React from 'react';
import './LandingPageEmpty.css'

const landingPageEmpty = () => (
    <div className="LandingPage-empty"></div>
);

export default landingPageEmpty;